import { ColorController } from "controllers";
import { withBaseMultiSelect } from "shared/HOC";

const ColorSelect = withBaseMultiSelect(ColorController.getColors());
export default ColorSelect;
